import http from 'axios'
import { push } from 'react-router-redux'
import { SubmissionError } from 'redux-form'

import { modalAction } from '../Modal/MessageModal'
import { getBillingAccounts } from '../Billing/Billing.actions'

export const generateShareToken = ({ path, method }) => ({
  type: 'AUTH/GENERATE_SHARE_TOKEN',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/share',
    data: {
      path,
      method,
    },
  }),
})

export const switchUser = userId => (dispatch, getState) =>
  dispatch({
    type: 'AUTH/SWITCH_USER',
    payload: http({
      method: 'POST',
      url: 'api/v1/auth/switchUser',
      data: {
        userId,
      },
    }),
    meta: {
      adminToken: getState().auth.token,
      adminUserId: getState().auth.user.id,
    },
  }).then(() => dispatch(push('/dashboard')))

export const switchBackToAdmin = () => (dispatch, getState) =>
  dispatch({
    type: 'AUTH/SWITCH_USER',
    payload: http({
      method: 'POST',
      url: 'api/v1/auth/switchUser',
      data: {
        userId: getState().auth.adminUserId,
      },
      headers: {
        Authorization: `bearer ${getState().auth.adminToken}`,
      },
    }),
    meta: {
      adminToken: null,
      adminUserId: null,
    },
  }).then(() => dispatch(push('/dashboard')))

export const login = ({ password, email }) => dispatch =>
  dispatch({
    type: 'AUTH/LOGIN',
    payload: http({
      method: 'POST',
      url: 'api/v1/auth/login',
      data: {
        username: email,
        password,
      },
      headers: {
        Authorization: null,
      },
    }),
  }).then(() => dispatch(getBillingAccounts()))

export const logout = () => dispatch => {
  dispatch(push('/'))
  return dispatch({
    type: 'AUTH/LOGOUT',
    payload: {},
  })
}

export const logoutTokenExpired = () => ({
  type: 'AUTH/LOGOUT_TOKEN_EXPIRED',
  payload: {},
})

export const registerUser = data => ({
  type: 'AUTH/REGISTER',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/register',
    data: {
      ...data,
      username: data.email,
    },
    headers: {
      Authorization: null,
    },
  }),
})

export const updateUser = data => ({
  type: 'AUTH/UPDATE_USER',
  payload: http({
    method: 'PUT',
    url: 'api/v1/auth/me',
    data,
  }),
})

export const loadUserData = () => ({
  type: 'AUTH/LOAD_USER_DATA',
  payload: http({
    method: 'GET',
    url: 'api/v1/auth/me',
  }),
})

export const updatePassword = ({ password, oldPassword }) => dispatch =>
  dispatch({
    type: 'AUTH/PASSWORD_UPDATE',
    payload: http({
      method: 'POST',
      url: 'api/v1/auth/updatePassword',
      data: {
        password,
        oldPassword,
      },
    }),
  }).catch(({ response }) => {
    throw new SubmissionError(response.data.validationErrors || {})
  })

export const passwordReset = ({ email }) => dispatch =>
  dispatch({
    type: 'AUTH/REQUEST_PASSWORD_RESET',
    payload: http({
      method: 'POST',
      url: 'api/v1/auth/forgotPassword',
      data: {
        email,
      },
    }),
  }).catch(({ response }) => {
    throw new SubmissionError(response.data.validationErrors || {})
  })

export const createEmailConfirmation = email => ({
  type: 'AUTH/CREATE_EMAIL_CONFIRMATION',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/verifyEmail',
    data: {
      email,
    },
  }),
})

export const confirmEmailWithCode = code => ({
  type: 'AUTH/CONFIRM_EMAIL',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/confirmEmail',
    data: {
      code,
    },
  }),
})

export const createPhoneConfirmation = phone => ({
  type: 'AUTH/CREATE_PHONE_CONFIRMATION',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/verifyPhone',
    data: {
      phone,
    },
  }),
})

export const confirmPhoneWithCode = code => ({
  type: 'AUTH/CONFIRM_PHONE',
  payload: http({
    method: 'POST',
    url: 'api/v1/auth/confirmPhone',
    data: {
      code,
    },
  }),
})

export const startAutoRefresh = () => ({
  type: 'AUTH/AUTO_REFRESH_USER_DATA_START',
})

export const stopAutoRefresh = () => ({
  type: 'AUTH/AUTO_REFRESH_USER_DATA_STOP',
})

export const stopDelay = delayName => ({
  type: 'AUTH/CREATE_TOKEN_DELAY_STOP',
  delayName,
})

export const tokenExpiredPopup = timeoutTime => (dispatch, getState) => {
  // timeoutTime: Time until we check for expiry again (ms)
  const showModal = () => {
    const expirationTime = new Date(getState().auth.expiration).getTime()
    const nowTime = new Date().getTime()
    const isExpired = expirationTime < nowTime
    if (isExpired) {
      const goToLogin = () => {
        dispatch(logoutTokenExpired())
        dispatch(push('/login'))
      }
      // We pop a modal and take them to the login page if their token has expired
      dispatch(
        modalAction({
          title: 'Unfortunately your session just expired.',
          body: "You'll need to login to Pickle again to continue.",
          hideClose: true,
        })
      )
        .then(goToLogin)
        .catch(goToLogin)
    }
  }
  setTimeout(showModal, timeoutTime)
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/Auth.actions.js